export default __webpack_public_path__ + "static/HHT-Budgetmeldung_1_1_en-7687523667f370ca30bad018b3c23659.jpg";